import useHttpQuery from '@actions/services/firestore/browser/useHttpQuery';
import type { ConfigListResponse, UseConfigsParams, UseConfigsResult } from './types';

const useConfigs = ({ agentId, enabled = true }: UseConfigsParams): UseConfigsResult => {
    const pathname = `/configs?agentId=${encodeURIComponent(agentId)}`;

    const { data, isLoading, error, refetch } = useHttpQuery<ConfigListResponse>({
        pathname,
        method: 'GET',
        key: ['configs', agentId],
        queryOptions: {
            enabled,
            staleTime: 0,
            cacheTime: 0,
        },
    });

    return {
        data: data?.data || [],
        isLoading,
        error: error || undefined,
        refetch,
    };
};

export default useConfigs;
